var lists_default = {
  "fontElementMap": "ep7xI",
  "orderedlist": "SItuO",
  "bulletedlist": "FQCnM",
  "listItem": "jdjSW"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
